export const hasOpenNaurEvents = (naurEventsData: ?Object): boolean => {
  return (
    naurEventsData?.naurEvents?.some((event) => event.status !== 'SATISFIED') ||
    false
  );
};
